import * as React from "react";
import "swiper/css";

type Props = {
  caption: string;
  type?: "title" | "source";
  data?: string;
};

export default function ImageCaption({
  caption,
  type = "title",
  data,
}: Props): React.ReactElement {
  if (type === "title") {
    return <figcaption>{caption}</figcaption>;
  }
  if (type === "source" && data) {
    return (
      <figcaption>
        <b>Source:&nbsp;&nbsp;</b>
        <a href={data} target="_blank">
          <em>{caption}</em>
        </a>
      </figcaption>
    );
  }
  return <figcaption>{caption}</figcaption>;
}
